import React from 'react';

/**
 * Full-page skeleton for offboarding wizard steps (Step 1–7).
 *
 * Mirrors the shared step chrome — page header, horizontal stepper and a form
 * card — so the initial page-load transition has spatial scaffolding instead of
 * a bare spinner. Per the DS loading standard: full page navigation => skeleton.
 *
 * Extracted from the original inline skeleton in OffboardingStep1 so every step
 * shares a single source of truth.
 */
const OffboardingStepSkeleton = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Page Header Skeleton */}
      <div className="bg-white">
        <div className="px-6 py-8 space-y-2">
          <div className="flex items-center justify-between">
            <div className="space-y-2">
              <div className="h-9 bg-gray-200 rounded w-80 animate-pulse"></div>
              <div className="h-6 bg-gray-200 rounded w-96 animate-pulse"></div>
            </div>
            <div className="flex items-center gap-3">
              <div className="h-10 bg-gray-200 rounded-full w-24 animate-pulse"></div>
              <div className="h-10 bg-gray-200 rounded-full w-32 animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Stepper Skeleton */}
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="flex items-center justify-between animate-pulse">
          {[1, 2, 3, 4, 5, 6].map(i => (
            <div key={i} className="flex items-center">
              <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
              {i < 6 && <div className="w-16 h-1 bg-gray-200 mx-2"></div>}
            </div>
          ))}
        </div>
      </div>

      {/* Form Content Skeleton */}
      <div className="px-6 py-8 max-w-4xl mx-auto">
        <div className="bg-white rounded-lg border p-6 space-y-6 animate-pulse">
          <div className="space-y-4">
            <div className="h-6 bg-gray-200 rounded w-48"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[1, 2, 3, 4].map(i => (
                <div key={i} className="space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-24"></div>
                  <div className="h-10 bg-gray-100 rounded-lg"></div>
                </div>
              ))}
            </div>
          </div>
          <div className="space-y-4">
            <div className="h-6 bg-gray-200 rounded w-40"></div>
            <div className="h-24 bg-gray-100 rounded-lg"></div>
          </div>
          <div className="space-y-4">
            <div className="h-6 bg-gray-200 rounded w-36"></div>
            <div className="h-32 bg-gray-100 rounded-lg border-2 border-dashed"></div>
          </div>
          <div className="flex justify-end gap-3 pt-4">
            <div className="h-10 bg-gray-200 rounded-full w-24"></div>
            <div className="h-10 bg-gray-200 rounded-full w-32"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OffboardingStepSkeleton;
